import Axios from 'axios';

const http = Axios.create({
  withCredentials: true,
});

http.interceptors.response
  .use(
    response => response,
    (error) => {
      // 認証エラー時の処理
      if (error.response.status === 401) {
        window.location.href = '#/not_signedin';
        location.reload();
        // システムエラー時の処理
      }
      return Promise.reject(error);
    });

export default http;
